/* ============================================================
   Placeholder contract payload — extracted verbatim from the approved
   prototype's `D` object (design-source/…dc.html). This is the FOUNDER-RULE
   fallback: any integration that is not yet connectable renders this data
   behind a "coming soon" / "connect me" flag, so the UI is always fully built.
   Regenerate: node scripts/extract-placeholder.mjs
   ============================================================ */
import type { Contract } from './contract';

export const PLACEHOLDER: Contract = {
  "user": {
    "name": "Cassidy Carr",
    "email": "cassidy@carrtech.ai",
    "role": "Founder · Director"
  },
  "health": [
    {
      "id": "site",
      "name": "Site",
      "sub": "carrtech.ai",
      "status": "green",
      "metric": "200 OK",
      "detail": "118ms p95",
      "icon": "globe"
    },
    {
      "id": "workers",
      "name": "Workers",
      "sub": "Cloudflare",
      "status": "green",
      "metric": "healthy",
      "detail": "3 regions · 0 cold",
      "icon": "server"
    },
    {
      "id": "ci",
      "name": "GitHub CI",
      "sub": "Actions",
      "status": "amber",
      "metric": "1 queued",
      "detail": "2 running · 1 waiting",
      "icon": "git"
    },
    {
      "id": "sentry",
      "name": "Sentry",
      "sub": "errors",
      "status": "red",
      "metric": "1 new",
      "detail": "spike · subscribe.ts",
      "icon": "bug"
    },
    {
      "id": "anthropic",
      "name": "Anthropic",
      "sub": "API",
      "status": "green",
      "metric": "operational",
      "detail": "430ms median",
      "icon": "spark"
    }
  ],
  "budget": {
    "spent": 666,
    "cap": 900,
    "tokensSpent": 44.4,
    "tokensCap": 60,
    "tokenUnit": "M tok",
    "daysLeft": 8,
    "perDay": 83,
    "pct": 74,
    "cycle": "June · resets in 8 days",
    "unit": "$"
  },
  "activity": [
    {
      "sys": "agent",
      "actor": "Forge",
      "text": "opened PR #128 · logbook view",
      "tone": "iris",
      "time": "12s"
    },
    {
      "sys": "ci",
      "actor": "",
      "text": "check suite started on PR #128",
      "tone": "warn",
      "time": "40s"
    },
    {
      "sys": "site",
      "actor": "",
      "text": "traffic spike · 48 visitors online",
      "tone": "cyan",
      "time": "1m"
    },
    {
      "sys": "agent",
      "actor": "Iris",
      "text": "pushed 3 screens to trailquest-web",
      "tone": "cyan",
      "time": "2m"
    },
    {
      "sys": "sentry",
      "actor": "",
      "text": "new issue · TypeError in subscribe.ts",
      "tone": "danger",
      "time": "6m"
    },
    {
      "sys": "deploy",
      "actor": "Vela",
      "text": "shipped carrtech-web to production",
      "tone": "iris",
      "time": "9m"
    },
    {
      "sys": "agent",
      "actor": "Scout",
      "text": "filed a brief on offline map SDKs",
      "tone": "cyan",
      "time": "17m"
    },
    {
      "sys": "human",
      "actor": "Cassidy",
      "text": "signed off trailquest-api v0.8",
      "tone": "iris",
      "time": "1h"
    },
    {
      "sys": "anthropic",
      "actor": "",
      "text": "budget crossed 70% · amber",
      "tone": "warn",
      "time": "1h"
    }
  ],
  "crew": [
    {
      "id": "atlas",
      "name": "Atlas",
      "glyph": "🧭",
      "role": "Orchestrator",
      "lead": true,
      "status": "running",
      "task": "Routing the trailquest-web build",
      "tokens": "8.2M",
      "elapsed": "2h 14m",
      "cost": 124,
      "model": "Opus 4.8",
      "tasksDone": 9,
      "reportsTo": ""
    },
    {
      "id": "forge",
      "name": "Forge",
      "glyph": "🔨",
      "role": "Build lead",
      "lead": true,
      "status": "running",
      "task": "PR #128 · logbook view",
      "tokens": "11.6M",
      "elapsed": "46m",
      "cost": 188,
      "model": "Sonnet 5",
      "tasksDone": 6,
      "reportsTo": "atlas"
    },
    {
      "id": "iris",
      "name": "Iris",
      "glyph": "🎨",
      "role": "Design",
      "lead": false,
      "status": "running",
      "task": "Badge shelf + quest-complete screen",
      "tokens": "4.1M",
      "elapsed": "1h 02m",
      "cost": 71,
      "model": "Sonnet 5",
      "tasksDone": 4,
      "reportsTo": "atlas"
    },
    {
      "id": "probe",
      "name": "Probe",
      "glyph": "🔬",
      "role": "QA",
      "lead": false,
      "status": "blocked",
      "task": "Waiting on preview deploy",
      "tokens": "2.3M",
      "elapsed": "18m",
      "cost": 32,
      "model": "Haiku 4.5",
      "tasksDone": 2,
      "reportsTo": "atlas"
    },
    {
      "id": "scout",
      "name": "Scout",
      "glyph": "🔭",
      "role": "Research",
      "lead": false,
      "status": "idle",
      "task": "Offline map brief — delivered",
      "tokens": "1.4M",
      "elapsed": "—",
      "cost": 19,
      "model": "Haiku 4.5",
      "tasksDone": 3,
      "reportsTo": "atlas"
    },
    {
      "id": "gate",
      "name": "Gate",
      "glyph": "🛡️",
      "role": "Security",
      "lead": false,
      "status": "errored",
      "task": "Secret scan failed on carrtech-web",
      "tokens": "0.9M",
      "elapsed": "4m",
      "cost": 12,
      "model": "Sonnet 5",
      "tasksDone": 1,
      "reportsTo": "atlas"
    }
  ],
  "roster": [
    {
      "name": "Atlas",
      "glyph": "🧭",
      "lead": true
    },
    {
      "name": "Forge",
      "glyph": "🔨",
      "lead": true
    },
    {
      "name": "Vela",
      "glyph": "⛵",
      "lead": false
    },
    {
      "name": "Tide",
      "glyph": "🌊",
      "lead": false
    },
    {
      "name": "Scout",
      "glyph": "🔭",
      "lead": false
    },
    {
      "name": "Quill",
      "glyph": "🪶",
      "lead": false
    },
    {
      "name": "Halo",
      "glyph": "🛟",
      "lead": false
    },
    {
      "name": "Gate",
      "glyph": "🛡️",
      "lead": false
    },
    {
      "name": "Pixel",
      "glyph": "📱",
      "lead": false
    },
    {
      "name": "Iris",
      "glyph": "🎨",
      "lead": false
    },
    {
      "name": "Probe",
      "glyph": "🔬",
      "lead": false
    },
    {
      "name": "Keel",
      "glyph": "⚓",
      "lead": false
    },
    {
      "name": "Beacon",
      "glyph": "🔦",
      "lead": false
    }
  ],
  "trace": [
    {
      "agent": "Forge",
      "step": "wrote src/pages/logbook.astro",
      "tone": "iris",
      "dur": "2.1s",
      "time": "12s"
    },
    {
      "agent": "Forge",
      "step": "ran build · 0 errors",
      "tone": "iris",
      "dur": "8.4s",
      "time": "34s"
    },
    {
      "agent": "Iris",
      "step": "exported BadgeShelf component",
      "tone": "cyan",
      "dur": "1.2s",
      "time": "1m"
    },
    {
      "agent": "Atlas",
      "step": "assigned QA pass to Probe",
      "tone": "iris",
      "dur": "0.3s",
      "time": "2m"
    },
    {
      "agent": "Gate",
      "step": "secret scan → 1 finding",
      "tone": "danger",
      "dur": "5.0s",
      "time": "4m"
    }
  ],
  "kanban": {
    "Research": [
      {
        "t": "Offline map SDK",
        "who": "🔭"
      }
    ],
    "Design": [
      {
        "t": "Badge shelf",
        "who": "🎨"
      },
      {
        "t": "Quest-complete",
        "who": "🎨"
      }
    ],
    "Build": [
      {
        "t": "Logbook view · PR #128",
        "who": "🔨"
      },
      {
        "t": "Subscribe fix",
        "who": "🔨"
      }
    ],
    "Live": [
      {
        "t": "trailquest-api v0.8",
        "who": "⚓"
      },
      {
        "t": "carrtech.ai",
        "who": "⛵"
      }
    ]
  },
  "site": {
    "requests": [
      42,
      38,
      51,
      47,
      63,
      58,
      72,
      69,
      61,
      78,
      74,
      66,
      81,
      92,
      88,
      79,
      96,
      104,
      98,
      112,
      119,
      108,
      124,
      131
    ],
    "requestsTotal": "1.9k",
    "requestsDelta": "+18%",
    "visitors": 312,
    "visitorsDelta": "+24",
    "online": 48,
    "uptime": "99.98%",
    "errorRate": "0.2%",
    "subscribers": 1284,
    "subsDelta": "+31",
    "topPages": [
      {
        "path": "/",
        "views": 842,
        "pct": 64
      },
      {
        "path": "/brand",
        "views": 268,
        "pct": 20
      },
      {
        "path": "/#contact",
        "views": 121,
        "pct": 9
      },
      {
        "path": "/#process",
        "views": 53,
        "pct": 4
      }
    ],
    "uniquesTrend": [
      {
        "date": "Mon",
        "uniques": 214
      },
      {
        "date": "Tue",
        "uniques": 246
      },
      {
        "date": "Wed",
        "uniques": 232
      },
      {
        "date": "Thu",
        "uniques": 289
      },
      {
        "date": "Fri",
        "uniques": 304
      },
      {
        "date": "Sat",
        "uniques": 187
      },
      {
        "date": "Sun",
        "uniques": 312
      }
    ],
    "sources": [
      {
        "label": "direct",
        "visits": 486,
        "pct": 44
      },
      {
        "label": "google.com",
        "visits": 302,
        "pct": 27
      },
      {
        "label": "github.com",
        "visits": 158,
        "pct": 14
      },
      {
        "label": "linkedin.com",
        "visits": 94,
        "pct": 9
      },
      {
        "label": "news.ycombinator.com",
        "visits": 66,
        "pct": 6
      }
    ],
    "countries": [
      {
        "label": "US",
        "visits": 512,
        "pct": 46
      },
      {
        "label": "GB",
        "visits": 178,
        "pct": 16
      },
      {
        "label": "DE",
        "visits": 132,
        "pct": 12
      },
      {
        "label": "CA",
        "visits": 118,
        "pct": 11
      },
      {
        "label": "AU",
        "visits": 84,
        "pct": 8
      }
    ],
    "devices": [
      {
        "label": "desktop",
        "visits": 634,
        "pct": 57
      },
      {
        "label": "mobile",
        "visits": 412,
        "pct": 37
      },
      {
        "label": "tablet",
        "visits": 60,
        "pct": 6
      }
    ],
    "vitals": {
      "lcpMs": 457,
      "cls": 0.008,
      "inpMs": 56,
      "lcpGrade": "good",
      "clsGrade": "good",
      "inpGrade": "good",
      "sampled": 1240
    },
    "notFound": [
      {
        "path": "/blog/launch",
        "count": 42
      },
      {
        "path": "/pricing",
        "count": 17
      },
      {
        "path": "/favicon.ico.bak",
        "count": 6
      }
    ],
    "formConversion": {
      "views": 1106,
      "submits": 24,
      "rate": "2.2%"
    }
  },
  "code": {
    "velocity": [
      3,
      5,
      2,
      8,
      6,
      11,
      7,
      9,
      4,
      12,
      8,
      14,
      10,
      11
    ],
    "velocityLabel": "commits / day",
    "prs": [
      {
        "id": 128,
        "title": "Logbook view + badge shelf",
        "author": "Forge",
        "age": "12m",
        "checks": "running",
        "repo": "trailquest-web"
      },
      {
        "id": 127,
        "title": "Fix subscribe.ts type error",
        "author": "Forge",
        "age": "3h",
        "checks": "failed",
        "repo": "carrtech-web"
      },
      {
        "id": 126,
        "title": "Quest completion endpoint",
        "author": "Keel",
        "age": "6h",
        "checks": "passed",
        "repo": "trailquest-api"
      },
      {
        "id": 119,
        "title": "Onboarding spike",
        "author": "Iris",
        "age": "2d",
        "checks": "queued",
        "repo": "app-02"
      }
    ],
    "oldest": "2d",
    "ci": {
      "passed": 18,
      "failed": 2,
      "running": 1,
      "queued": 1
    },
    "deploys": [
      {
        "sha": "a3f9c1e",
        "env": "production",
        "status": "passed",
        "repo": "carrtech-web",
        "time": "9m"
      },
      {
        "sha": "7b21d04",
        "env": "preview",
        "status": "passed",
        "repo": "trailquest-web",
        "time": "41m"
      },
      {
        "sha": "c0a8f55",
        "env": "production",
        "status": "failed",
        "repo": "carrtech-web",
        "time": "3h"
      },
      {
        "sha": "e94120a",
        "env": "production",
        "status": "passed",
        "repo": "trailquest-api",
        "time": "6h"
      },
      {
        "sha": "2f7b9cd",
        "env": "preview",
        "status": "passed",
        "repo": "app-02",
        "time": "1d"
      }
    ],
    "repos": [
      {
        "name": "carrtech-ai-portal",
        "openPrs": 1,
        "awaitingReview": 1,
        "oldestPr": "3h",
        "ciRate": 96,
        "lastRun": {
          "status": "passed",
          "when": "2h"
        },
        "openIssues": 4,
        "release": "v0.1.0",
        "alerts": 0,
        "needsAttention": []
      },
      {
        "name": "carrtech-web",
        "openPrs": 2,
        "awaitingReview": 1,
        "oldestPr": "1d",
        "ciRate": 88,
        "lastRun": {
          "status": "failed",
          "when": "3h"
        },
        "openIssues": 7,
        "release": "v1.4.2",
        "alerts": 3,
        "needsAttention": [
          "failing CI",
          "3 security alerts"
        ]
      },
      {
        "name": "trailquest",
        "openPrs": 2,
        "awaitingReview": 0,
        "oldestPr": "6h",
        "ciRate": 94,
        "lastRun": {
          "status": "passed",
          "when": "5h"
        },
        "openIssues": 12,
        "release": "v2.4.0",
        "alerts": 1,
        "needsAttention": [
          "1 security alert"
        ]
      },
      {
        "name": "company",
        "openPrs": 0,
        "awaitingReview": 0,
        "oldestPr": "—",
        "ciRate": null,
        "lastRun": null,
        "openIssues": 2,
        "release": "—",
        "alerts": 0,
        "needsAttention": []
      },
      {
        "name": ".github",
        "openPrs": 0,
        "awaitingReview": 0,
        "oldestPr": "—",
        "ciRate": null,
        "lastRun": null,
        "openIssues": 0,
        "release": "—",
        "alerts": 0,
        "needsAttention": []
      }
    ],
    "org": {
      "awaitingReview": 2,
      "ciRate": 93,
      "alerts": 4,
      "openIssues": 25
    }
  },
  "money": {
    "spend30": [
      12,
      18,
      9,
      24,
      31,
      22,
      28,
      41,
      35,
      52,
      44,
      38,
      61,
      49,
      57,
      72,
      66,
      58,
      83,
      74,
      69,
      88,
      81,
      76,
      94,
      83,
      79,
      91,
      86,
      83
    ],
    "byModel": [
      {
        "name": "Claude Opus",
        "pct": 58,
        "usd": 386,
        "tone": "iris"
      },
      {
        "name": "Claude Sonnet",
        "pct": 34,
        "usd": 226,
        "tone": "cyan"
      },
      {
        "name": "Claude Haiku",
        "pct": 8,
        "usd": 54,
        "tone": "muted"
      }
    ],
    "infra": [
      {
        "name": "Cloudflare",
        "usd": 5,
        "note": "Pages + Workers + D1"
      },
      {
        "name": "Resend",
        "usd": 0,
        "note": "free tier"
      },
      {
        "name": "Sentry",
        "usd": 0,
        "note": "free tier"
      }
    ]
  },
  "audit": [
    {
      "actor": "Cassidy",
      "action": "Signed off & shipped",
      "target": "carrtech-web → prod",
      "result": "ok",
      "time": "9m"
    },
    {
      "actor": "Cassidy",
      "action": "Ran agent",
      "target": "Forge · logbook view",
      "result": "ok",
      "time": "46m"
    },
    {
      "actor": "Cassidy",
      "action": "Toggled flag",
      "target": "trailquest.badges = on",
      "result": "ok",
      "time": "2h"
    },
    {
      "actor": "Cassidy",
      "action": "Silenced alert",
      "target": "Sentry · subscribe.ts",
      "result": "ok",
      "time": "3h"
    },
    {
      "actor": "Cassidy",
      "action": "Health-check",
      "target": "all systems",
      "result": "ok",
      "time": "5h"
    }
  ],
  "chat": [
    {
      "from": "ai",
      "text": "Morning, Cassidy. The crew is on trailquest-web — Forge has PR #128 open and checks are running. Gate flagged a secret on carrtech-web; I paused that deploy."
    },
    {
      "from": "me",
      "text": "What did Gate find?"
    },
    {
      "from": "ai",
      "text": "A test Resend key committed to src/lib/mail.ts. I can open a PR that moves it to a Pages secret and rotates it — want me to send Forge that task?"
    }
  ],
  "apps": [
    {
      "id": "trailquest",
      "name": "TrailQuest",
      "glyph": "🏔️",
      "tag": "iOS · v2.4.0",
      "store": "App Store"
    }
  ],
  "reviews": {
    "rating": "4.8",
    "ratingDelta": "+0.1",
    "totalRatings": "2,417",
    "needsReply": 6,
    "weekVolume": 34,
    "oneStarWeek": 3,
    "dist": [
      {
        "stars": 5,
        "n": 1841
      },
      {
        "stars": 4,
        "n": 372
      },
      {
        "stars": 3,
        "n": 121
      },
      {
        "stars": 2,
        "n": 47
      },
      {
        "stars": 1,
        "n": 36
      }
    ],
    "trend": [
      4.5,
      4.6,
      4.6,
      4.7,
      4.7,
      4.8,
      4.9,
      4.8
    ],
    "platforms": [
      {
        "name": "App Store",
        "note": "iOS · live",
        "status": "connected"
      },
      {
        "name": "Google Play",
        "note": "Android · Q3",
        "status": "soon"
      },
      {
        "name": "Product Hunt",
        "note": "launch day",
        "status": "soon"
      }
    ],
    "themes": [
      {
        "label": "Badge system",
        "tone": "cyan",
        "kind": "loved",
        "n": 41
      },
      {
        "label": "Quest variety",
        "tone": "cyan",
        "kind": "loved",
        "n": 27
      },
      {
        "label": "Offline maps",
        "tone": "danger",
        "kind": "issue",
        "n": 18,
        "issue": "TileCache.download timeout"
      },
      {
        "label": "Battery on tracking",
        "tone": "warn",
        "kind": "issue",
        "n": 14,
        "issue": "LocationManager wakelock"
      },
      {
        "label": "Cross-device sync",
        "tone": "warn",
        "kind": "issue",
        "n": 9,
        "issue": "SyncEngine 409"
      },
      {
        "label": "Onboarding",
        "tone": "muted",
        "kind": "mixed",
        "n": 7
      }
    ],
    "feed": [
      {
        "id": "r1",
        "stars": 5,
        "title": "Best trail app I’ve used",
        "body": "The quests actually get me out the door on weekends. Offline mode saved me deep in the backcountry with no signal.",
        "author": "SummitSeeker42",
        "ver": "2.4.0",
        "flag": "🇺🇸",
        "when": "2h",
        "replied": false,
        "critical": false
      },
      {
        "id": "r2",
        "stars": 2,
        "title": "Offline maps won’t download",
        "body": "Tapped download on three trails and the spinner just hangs on iOS 18. Was my favorite app until this update — please fix.",
        "author": "NorthwestHiker",
        "ver": "2.4.0",
        "flag": "🇺🇸",
        "when": "5h",
        "replied": false,
        "critical": true
      },
      {
        "id": "r3",
        "stars": 5,
        "title": "The badges are addictive",
        "body": "Collected 14 so far and my whole hiking group is competing now. So well done.",
        "author": "trailmix_pnw",
        "ver": "2.4.0",
        "flag": "🇨🇦",
        "when": "9h",
        "replied": true,
        "critical": false
      },
      {
        "id": "r4",
        "stars": 3,
        "title": "Great, but battery hungry",
        "body": "Live tracking drains ~30% on a half-day hike. Would love a low-power mode for longer trips.",
        "author": "weekendwanderer",
        "ver": "2.3.1",
        "flag": "🇬🇧",
        "when": "1d",
        "replied": false,
        "critical": false
      },
      {
        "id": "r5",
        "stars": 1,
        "title": "Lost my progress after update",
        "body": "Opened the app today and all my saved quests and my 40-day streak are gone. Gutted. Please help me get them back.",
        "author": "lost_on_trail",
        "ver": "2.4.0",
        "flag": "🇺🇸",
        "when": "1d",
        "replied": false,
        "critical": true
      },
      {
        "id": "r6",
        "stars": 5,
        "title": "Quest system is genius",
        "body": "Feels like a game but gets me onto real trails. Worth every penny of Pro.",
        "author": "peakbagger",
        "ver": "2.4.0",
        "flag": "🇦🇺",
        "when": "2d",
        "replied": true,
        "critical": false
      },
      {
        "id": "r7",
        "stars": 4,
        "title": "Love it — sync could be better",
        "body": "Now and then my iPad and iPhone disagree on which quests I’ve finished. Small thing.",
        "author": "dualdevice",
        "ver": "2.3.1",
        "flag": "🇩🇪",
        "when": "3d",
        "replied": true,
        "critical": false
      }
    ],
    "drafts": {
      "r2": "Thanks for flagging this — we can see offline downloads hanging on iOS 18 and Scout is already on a fix. In the meantime, Settings → Storage → Clear tile cache usually unblocks it. We’ll reply here the moment 2.4.1 ships.",
      "r4": "Appreciate the detail! A low-power tracking mode is in the works — Forge is roughly halving GPS polling for long hikes. Landing in the next update. Thanks for getting out there with us.",
      "r5": "So sorry about this — we’re treating it as critical and Forge is on it right now. Your data isn’t lost; it’s safe on our servers. Email cassidy@carrtech.ai and we’ll restore your quests and streak today."
    }
  },
  "perf": {
    "downloads": {
      "total": "8,940",
      "delta": "+22%",
      "spark": [
        180,
        210,
        190,
        240,
        260,
        230,
        280,
        310,
        290,
        340,
        320,
        360,
        300,
        380,
        410,
        390,
        360,
        420,
        440,
        410,
        460,
        480,
        450,
        470,
        510,
        490,
        520,
        560,
        540,
        590
      ]
    },
    "dau": {
      "value": "3,120",
      "delta": "+8%",
      "mau": "14.2k",
      "stickiness": "22%"
    },
    "crashFree": {
      "value": "99.6%",
      "delta": "+0.2pt",
      "detail": "sessions · 30d"
    },
    "retention": {
      "d1": 68,
      "d7": 41,
      "d30": 24
    },
    "funnel": [
      {
        "label": "Impressions",
        "value": "128k",
        "pct": 100
      },
      {
        "label": "Product page views",
        "value": "41.0k",
        "pct": 32
      },
      {
        "label": "Downloads",
        "value": "8,940",
        "pct": 22
      }
    ],
    "conversion": "7.0%",
    "crashSpark": [
      99,
      99.1,
      99,
      99.3,
      99.2,
      99.4,
      99.3,
      99.5,
      99.4,
      99.6,
      99.7,
      99.6
    ],
    "versions": [
      {
        "v": "2.4.0",
        "pct": 78,
        "tone": "iris"
      },
      {
        "v": "2.3.1",
        "pct": 16,
        "tone": "cyan"
      },
      {
        "v": "≤ 2.3.0",
        "pct": 6,
        "tone": "muted"
      }
    ],
    "issues": [
      {
        "id": "i1",
        "title": "ProgressStore write conflict",
        "sev": "critical",
        "sessions": 18,
        "users": 12,
        "ver": "2.4.0",
        "status": "investigating",
        "agent": "Forge",
        "glyph": "🔨"
      },
      {
        "id": "i2",
        "title": "TileCache.download timeout",
        "sev": "high",
        "sessions": 42,
        "users": 31,
        "ver": "2.4.0",
        "status": "open",
        "agent": "Scout",
        "glyph": "🔭"
      },
      {
        "id": "i3",
        "title": "LocationManager battery wakelock",
        "sev": "medium",
        "sessions": 88,
        "users": 54,
        "ver": "2.3.1",
        "status": "open",
        "agent": "",
        "glyph": ""
      },
      {
        "id": "i4",
        "title": "SyncEngine 409 conflict",
        "sev": "medium",
        "sessions": 23,
        "users": 15,
        "ver": "2.4.0",
        "status": "triaged",
        "agent": "Forge",
        "glyph": "🔨"
      },
      {
        "id": "i5",
        "title": "BadgeShelf render NPE",
        "sev": "low",
        "sessions": 6,
        "users": 5,
        "ver": "2.4.0",
        "status": "fixed",
        "agent": "Iris",
        "glyph": "🎨"
      }
    ]
  },
  "approvals": [
    {
      "id": "ap1",
      "kind": "deploy",
      "title": "Deploy carrtech-web to production",
      "detail": "Forge finished the hardening pass — build green, QA green, wants the ship signed off.",
      "requestedBy": "Forge",
      "glyph": "🔨",
      "time": "12m",
      "status": "pending",
      "urgency": "high"
    },
    {
      "id": "ap2",
      "kind": "merge",
      "title": "Merge PR #128 · logbook view",
      "detail": "All checks passed · Probe signed off the QA sweep · touches trailquest-web only.",
      "requestedBy": "Atlas",
      "glyph": "🧭",
      "time": "38m",
      "status": "pending",
      "urgency": "normal"
    },
    {
      "id": "ap3",
      "kind": "spend",
      "title": "Raise June token budget by $100",
      "detail": "Budget at 74% with 8 days left — Atlas projects an overrun on the current burn.",
      "requestedBy": "Atlas",
      "glyph": "🧭",
      "time": "1h",
      "status": "pending",
      "urgency": "normal"
    },
    {
      "id": "ap4",
      "kind": "token",
      "title": "Create a fine-grained GitHub token for Code tiles",
      "detail": "Read-only: PRs, checks, Dependabot alerts across CarrTech-AI. Paste as GITHUB_TOKEN.",
      "requestedBy": "Keel",
      "glyph": "⚓",
      "time": "3h",
      "status": "pending",
      "urgency": "normal"
    }
  ],
  "tasks": [
    {
      "id": "tk1",
      "text": "Rotate the leaked Resend key and open a PR",
      "from": "Cassidy",
      "assignee": "Forge",
      "status": "in-progress",
      "time": "18m"
    },
    {
      "id": "tk2",
      "text": "Brief: offline map SDK options for TrailQuest",
      "from": "Cassidy",
      "assignee": "Scout",
      "status": "done",
      "time": "2h"
    },
    {
      "id": "tk3",
      "text": "Fix the Start-a-build form email confirmation",
      "from": "portal",
      "assignee": "",
      "status": "queued",
      "time": "4h"
    }
  ],
  "inbox": [
    {
      "id": "in1",
      "text": "Trail-condition reports as a community layer — users flag mud/closures on the map",
      "bucket": "project",
      "tags": [
        "trailquest",
        "community"
      ],
      "score": {
        "profit": 4,
        "effort": 3,
        "safety": 5,
        "total": 80
      },
      "time": "2h",
      "author": "Cassidy"
    },
    {
      "id": "in2",
      "text": "Weekly automated changelog email to subscribers from merged PRs",
      "bucket": "backlog",
      "tags": [
        "growth",
        "automation"
      ],
      "score": {
        "profit": 3,
        "effort": 2,
        "safety": 5,
        "total": 75
      },
      "time": "1d",
      "author": "Scout"
    },
    {
      "id": "in3",
      "text": "Gift a TrailQuest Pro month when a friend finishes their first quest",
      "bucket": "idea",
      "tags": [
        "growth"
      ],
      "score": null,
      "time": "2d",
      "author": "Cassidy"
    }
  ],
  "threads": {
    "atlas": [
      {
        "from": "Cassidy",
        "text": "Ship the v2 portal tonight if QA's green.",
        "time": "3h",
        "dir": "up"
      },
      {
        "from": "Atlas",
        "text": "Routing: Forge on the build, Probe on QA, Iris on fidelity. I'll gate the deploy behind your approval.",
        "time": "2h58m",
        "dir": "self"
      },
      {
        "from": "Atlas",
        "text": "Forge — take the approvals queue + founder inbox. Keel — the connectors.",
        "time": "2h50m",
        "dir": "down"
      },
      {
        "from": "Atlas",
        "text": "QA green. Queued a deploy approval for you.",
        "time": "8m",
        "dir": "up"
      }
    ],
    "forge": [
      {
        "from": "Atlas",
        "text": "Take PR #128 — logbook view. Probe's waiting to QA.",
        "time": "2h",
        "dir": "up"
      },
      {
        "from": "Forge",
        "text": "On it — wiring the logbook view + badge shelf.",
        "time": "1h58m",
        "dir": "self"
      },
      {
        "from": "Forge",
        "text": "Keel — need the quest-complete endpoint shape.",
        "time": "1h30m",
        "dir": "down"
      },
      {
        "from": "Keel",
        "text": "Shipped trailquest-api v0.8 — endpoint's live.",
        "time": "1h10m",
        "dir": "down"
      },
      {
        "from": "Forge",
        "text": "Build green, checks running. Ready for Probe.",
        "time": "12s",
        "dir": "self"
      }
    ],
    "scout": [
      {
        "from": "Cassidy",
        "text": "Research offline-map SDK options for TrailQuest.",
        "time": "1d",
        "dir": "up"
      },
      {
        "from": "Scout",
        "text": "Brief filed: Mapbox vs Protomaps vs self-host. Recommendation inside.",
        "time": "22h",
        "dir": "self"
      }
    ],
    "gate": [
      {
        "from": "Gate",
        "text": "Secret scan failed on carrtech-web — a test Resend key is committed.",
        "time": "5m",
        "dir": "self"
      },
      {
        "from": "Gate",
        "text": "Atlas — flagging to Approvals: rotate + move to a secret.",
        "time": "4m",
        "dir": "up"
      }
    ]
  },
  "plan": {
    "now": [
      {
        "t": "Mission Control v2 — approvals + founder inbox",
        "owner": "Forge",
        "status": "In build",
        "area": "Product"
      },
      {
        "t": "Site hardening — 5-PR plan (A–E)",
        "owner": "Forge",
        "status": "In build",
        "area": "Ops/Infra"
      },
      {
        "t": "Fix Start-a-build form + email confirm",
        "owner": "Keel",
        "status": "To do",
        "area": "Product"
      }
    ],
    "next": [
      {
        "t": "Apple Developer — Organization enrollment",
        "owner": "Cassidy",
        "status": "Waiting",
        "area": "Business"
      },
      {
        "t": "Unit tests + reliably green CI",
        "owner": "Probe",
        "status": "To do",
        "area": "Ops/Infra"
      }
    ],
    "later": [
      {
        "t": "TrailQuest Android build",
        "owner": "",
        "status": "Parked",
        "area": "Product"
      },
      {
        "t": "Model-router for per-task cost control",
        "owner": "Atlas",
        "status": "Parked",
        "area": "Ops/Infra"
      }
    ]
  },
  "ido": [
    {
      "id": "id1",
      "text": "Paste ANTHROPIC_API_KEY so Talk-to-AI goes live",
      "done": false,
      "source": "auto",
      "time": "1h"
    },
    {
      "id": "id2",
      "text": "Create the fine-grained GitHub token (Code tiles)",
      "done": false,
      "source": "auto",
      "time": "3h"
    },
    {
      "id": "id3",
      "text": "Gate the v2 preview behind Cloudflare Access",
      "done": false,
      "source": "auto",
      "time": "5h"
    },
    {
      "id": "id4",
      "text": "Sign the D-U-N-S paperwork for Apple enrollment",
      "done": true,
      "source": "me",
      "time": "2d"
    }
  ],
  "heartbeat": [
    {
      "agent": "Forge",
      "host": "forge-cax11",
      "online": true,
      "state": "online",
      "lastSeen": "22s"
    }
  ]
};
